<template>
  <div class="page-title">
    <div class="row">
      <div class="col-sm-6 col-12">
        <h2> All Drivers</h2>
      </div>
    </div>
  </div>

  <div class="card height-equal-2">
    <div class="card-header card-no-border pb-0">
      <ul class="nav nav-tabs" id="icon-tab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="all-rides-tab" data-bs-toggle="tab"
             href="#all-drivers" role="tab" aria-controls="all-rides" aria-selected="true">
            <i class="fa-solid fa-users text-primary"></i>
            All Drivers
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="dispatched-rides-tab" data-bs-toggle="tab"
             href="#available-drivers" role="tab" aria-controls="dispatched-rides" aria-selected="false">
            <i class="fa-solid fa-circle-check text-success"></i>
            Available Drivers
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="ordered-rides-tab" data-bs-toggle="tab"
             href="#on-ride-drivers" role="tab" aria-controls="ordered-rides" aria-selected="false">
            <i class="fa-solid fa-car-side text-warning"></i>
            On Ride Drivers
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" id="ordered-rides-tab" data-bs-toggle="tab"
             href="#offline-drivers" role="tab" aria-controls="ordered-rides" aria-selected="false">
            <i class="fa-solid fa-circle-xmark text-danger"></i>
            Offline Drivers
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content" id="icon-tabContent">
        <div class="tab-pane fade show active" id="all-drivers" role="tabpanel" aria-labelledby="icon-home-tab">
          <DataTable
              :ajax="{ url: driversUrl}"
              ref="allRides" class="table-responsive display custom-datatable" :columns="allColumnDefinition"/>
        </div>

        <div class="tab-pane fade" id="available-drivers" role="tabpanel" aria-labelledby="profile-icon-tabs">
                    <DataTable
                        :ajax="{ url: availableUrl}"
                        ref="dispatchedRides" class="table-responsive display" :columns="filteredColumn"/>
        </div>

        <div class="tab-pane fade" id="on-ride-drivers" role="tabpanel" aria-labelledby="contact-icon-tab">
                    <DataTable
                        :ajax="{ url: onRideUrl}"
                        ref="orderedRides" class="table-responsive display" :columns="filteredColumn"/>
        </div>

        <div class="tab-pane fade" id="offline-drivers" role="tabpanel" aria-labelledby="contact-icon-tab">
          <DataTable
              :ajax="{ url: offlineUrl}"
              ref="orderedRides" class="table-responsive display" :columns="filteredColumn"/>
        </div>


      </div>
    </div>
  </div>
</template>

<script setup>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import {driverStatus, userDetailsWithThumbnail, zonedDateTime} from "../utility/DatatableRenderer";
import {newEntityId} from '../globals.js';
DataTable.use(DataTablesCore);

const props = defineProps({
  serviceProviderId: { type: String, default: newEntityId }
});

const driversUrl = `/api/datatable/sp-all-drivers/${props.serviceProviderId}`;
const availableUrl = `${driversUrl}?status=AVAILABLE`;
const onRideUrl = `${driversUrl}?status=ON_RIDE`
const offlineUrl = `${driversUrl}?status=OFFLINE`

// Define columns
const allColumnDefinition = [
  {
    title: "Driver", data: "name", render: (data, type, row) => {
      return userDetailsWithThumbnail(data, row, `/service-provider/${props.serviceProviderId}/driver/${row.id}`);
    }
  },
  {data: "email",title: "Email", },
  {data: "phoneNumber", title: 'Phone Number'},
  {
    data: "totalRides", title: 'Rides',orderable: false, searchable: false,
    render: (data, type, row) => {
      return `<span style="min-width: 125px;">
                    Total <span class="text-primary">${data}</span> |
                    Completed <span class="text-success">${row.ridesCompleted}</span> |
                    Canceled <span class="text-danger">${row.ridesCancelled}</span>
              </span>`;
    }
  },
  {data: "driverStatus", title: 'Status', render: driverStatus},
  {data: "joinedOn", title: 'Joined At', render: zonedDateTime},
  {
    title: 'Actions', orderable: false, searchable: false, render: (data, type, row) => {
      return `<a class="btn btn-outline-primary"" data-id="${row.id}"
        href="/service-provider/${props.serviceProviderId}/driver/${row.id}">
      <i class="iconly-Info-Circle icbr"></i> Details </a>`;
    }
  }
];

const filteredColumn = [
  {
    title: "Driver", data: "name", render: (data, type, row) => {
      return userDetailsWithThumbnail(data, row, `/service-provider/${props.serviceProviderId}/driver/${row.id}`);
    }
  },
  {data: "email",title: "Email", },
  {data: "phoneNumber", title: 'Phone Number'},
  {
    data: "totalRides", title: 'Rides',orderable: false, searchable: false,
    render: (data, type, row) => {
      return `<span style="min-width: 125px;">
                    Total <span class="text-primary">${data}</span> |
                    Completed <span class="text-success">${row.ridesCompleted}</span> |
                    Canceled <span class="text-danger">${row.ridesCancelled}</span>
              </span>`;
    }
  },
  {data: "joinedOn", title: 'Joined At', render: zonedDateTime},
  {
    title: 'Actions', orderable: false, searchable: false, render: (data, type, row) => {
      return `<a class="btn btn-outline-primary"" data-id="${row.id}"
       href="/service-provider/${props.serviceProviderId}/driver/${row.id}">
      <i class="iconly-Info-Circle icbr"></i> Details </a>`;
    }
  }
];

</script>